let TransBankPaymentType = {
    AMERICAN_EXPRESS: 1,
    DINERS: 2,
    JCB: 4,
    MASTERCARD: 5,
    CABAL: 8,
    NARANJA: 9,
    KADICARD: 10,
    VISA: 14,
    FAVACARD: 15,
    LIDER: 17,
    CREDIMAS: 20,
    NEVADA: 21,
    VISA_NARANJA: 29,
    PATAGONIA_365: 33,
    SOL: 34,
    CMR_FALABELLA: 35,
    T_SHOPPING: 42,
    ITALCRED: 43,
    CLUB_LA_NACION: 45,
    CLUB_PERSONAL: 46,
    CLUB_ARNET: 47,
    MAS_CENCOSUD: 48,
    NARANJA_MO: 49,
    PYME_NACION: 50,
    CLARIN_365: 51,
    CLUB_SPEEDY: 52,
    ARGENTA: 53,
    VISA_DEBITO: 55,
    CLUB_LA_VOZ: 58,
    NEXO: 61,
    NATIVA: 63,
    ARGENCARD: 65,
    CONSUMAX:72,
    COOPEPLUS: 95,
    DISCOVER: 101,
    ELO: 102,
    MAGNA: 103,
    AURA: 104,
    HIPERCARD: 105,
    CREDENCIAL_COL: 106,
    REDCOMPRA: 107,
    BBPS: 110,
    UNIONPAY: 115,
    HIPER: 116,
    AR_RAPIPAGO: 300,
    AR_PAGOFACIL: 301,
    AR_BAPROPAGOS: 302,
    AR_RIPSA: 303,
    AR_COBRO_EXPRESS: 304,
    CL_SERIPAG: 305,
    BR_BOLETO_ITAU: 306,
    MX_SEVEN_ELEVEN: 307,
    MX_OXXO: 308,
    MX_BANCOMER: 309,
    MX_SANTANDER: 310,
    MX_IXE: 311,
    MX_SCOTIABANK: 312,
    CL_SENCILLITO: 313,
    PAGOMISCUENTAS: 320,
    SAFETYPAY: 321
};

export default TransBankPaymentType;